import { render, staticRenderFns } from "./AddBankAccountModal.vue?vue&type=template&id=0ba4b9f4&scoped=true"
import script from "./AddBankAccountModal.vue?vue&type=script&lang=js"
export * from "./AddBankAccountModal.vue?vue&type=script&lang=js"
import style0 from "./AddBankAccountModal.vue?vue&type=style&index=0&id=0ba4b9f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4b9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba4b9f4')) {
      api.createRecord('0ba4b9f4', component.options)
    } else {
      api.reload('0ba4b9f4', component.options)
    }
    module.hot.accept("./AddBankAccountModal.vue?vue&type=template&id=0ba4b9f4&scoped=true", function () {
      api.rerender('0ba4b9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/AddBankAccountModal.vue"
export default component.exports